module.exports = __webpack_public_path__ + "img/Logo_crop.1172a48e.jpg";